import { useEffect, useState } from "react";
import dailyFilterDefault from "@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault";
import { useSelector, shallowEqual } from 'umi';
import { addLastDateRequestValue, formatFilterValues } from "@/pages/dashboard/utils/utils";
import { getPcV3DailyCountryRegionPlatform } from "@/pages/dashboard/services/overview";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const metricReqObj: { [key: string]: string; } = {
  dau: 'dau',
  new: 'new',
  units: 'units',
  revenue: 'platform_net_revenue',
  inflexion_new_churn: 'new_churn',
  gross_full_game_units: 'gross_full_game_units',
  gross_revenue: 'gross_revenue',
};

const usePlatformData = (
  filterVal: any,
  filterLoading: boolean,
  api: string,
  haveCalBubble: boolean,
  period: string,
  by_type: string,
  metric: string,
  haveLastDate?: boolean,
  timeZone?: number,
  extraParams?: Record<string, any>
) => {
  const formVal = filterVal || dailyFilterDefault;
  const [componentData, setComponentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const gameCode = useSelector((state: any) => {
    return state.dashboard?.currentGame?.game_code;
  }, shallowEqual);

  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal || !haveCalBubble || by_type !== 'os') return;
    if (!filterLoading) {
      getPcDailyCountryRegionPlatformDataFunc();
    }
  }, [formVal, metric, by_type]);

  const getPcDailyCountryRegionPlatformDataFunc = (isRefresh?: boolean) => {
    const { timeType, diff, ...filterValue } = filterVal;
    const updatedFilterValue = {
      ...filterValue,
      system: ["255"],
    };

    const { rangeTime: [start, end], ...filters } = updatedFilterValue;
    let params: any = {
      game_code: gameCode,
      start_time: start,
      end_time: end,
      period,
      filters: formatFilterValues(filters),
      by_type,
      metric: metricReqObj?.[metric],
      has_top_data: true,
      top_num: 1000,
      ...extraParams
    };
    params = addLastDateRequestValue(params, haveLastDate, timeZone);
    setLoading(!isRefresh);
    getPcV3DailyCountryRegionPlatform(api, params).then((result: any) => {
      setError(false);
      setLoading(false);
      setComponentData(result);
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default usePlatformData;